/**
 * Megan's realtime voice-agent model ids. Leaf module — the desk settings and
 * the Voice Agent client both read these without an import cycle.
 *
 * The model is the intelligence on the call. The *voice* is `ara` and does not
 * change with a model bump.
 */

/** Pinned flagship. Not the floating alias — an alias flip must not change Megan. */
export const XAI_VOICE_AGENT_MODEL = "grok-voice-think-fast-2.0";

/** Floating alias the desk shipped before. Treated as "not pinned" on load. */
export const XAI_VOICE_AGENT_MODEL_ALIAS = "grok-voice-latest";

/** Previous-generation voice model — still pinnable from Settings. */
export const XAI_VOICE_AGENT_MODEL_PREVIOUS = "grok-voice-think-fast-1.0";

/** Megan default: warm / friendly (more North American). Override with XAI_VOICE_ID or Settings. */
export const DEFAULT_VOICE_AGENT_VOICE = "ara";

/**
 * think-fast-2.0 defaults to high-effort reasoning. On a phone brief that is a
 * silent stall after "I'll check the live board." Dispatch reads stay prompt.
 */
export const XAI_VOICE_REASONING_EFFORT = "none";

/** Resolve a saved Settings value. Empty or the legacy alias lands on the pinned flagship. */
export function resolveVoiceAgentModel(saved?: string | null): string {
  const value = typeof saved === "string" ? saved.trim() : "";
  if (!value || value === XAI_VOICE_AGENT_MODEL_ALIAS) return XAI_VOICE_AGENT_MODEL;
  return value;
}
